// NOTE: avoid line break when dealing with template literals. Template literals will add every line break in it in the UI.
export const OptionFormater = (option, lang) => {
  const firstName = option.first_name && (option.first_name[lang] || option.first_name.en || '')
  const lastName = option.last_name && (option.last_name[lang] || option.last_name.en || '')
  const hierarchyName = option?.hierarchy_name? (option.hierarchy_name[lang] || option.hierarchy_name.en || "") : ""

  return `${firstName} ${lastName} ${hierarchyName? `- (${hierarchyName})` : ""}`.trim();
}